import {EventEmitter} from "./EventEmitter";

export class QuantityCounter {
	constructor(quantityCounter, params = {}) {
		this.emitter = new EventEmitter();

		this.$quantityCounter = $(quantityCounter);

		this.$input = params.input || this.$quantityCounter.find(`[data-counter="input"]`);
		this.$minus = params.minus || this.$quantityCounter.find(`[data-counter="minus"]`);
		this.$plus = params.plus || this.$quantityCounter.find(`[data-counter="plus"]`);
		this.autoIncrease = params.autoIncrease !== false;

		this.MIN = parseInt(this.$input.attr("min")) || 0;
		this.MAX = parseInt(this.$input.attr("max")) || null;

		this.value = parseInt(this.$input.val()) || 0;

		this.init();
	}

	init() {
		this.checkMinValue();
		this.checkMaxValue();

		this.setUpListeners();
	}

	setUpListeners() {
		this.$plus.on("click", () => {
			if (this.autoIncrease) {
				this.increaseValue();
				this.checkMinValue();
				this.checkMaxValue();
			}

			this.emitter.emit("event:increase-value");
		});

		this.$minus.on("click", () => {
			if (this.autoIncrease) {
				this.decreaseValue();
				this.checkMaxValue();
				this.checkMinValue();
			}
			this.emitter.emit("event:decrease-value");
		});

		this.$input.on("input", () => {
			this.updateVal();
			this.checkMinValue();
			this.checkMaxValue();

			this.emitter.emit("event:input-value");
		});
	}

	on(action, fn) {
		if (action === "increase") {
			this.emitter.subscribe("event:increase-value", data => fn(data));
		}
		if (action === "decrease") {
			this.emitter.subscribe("event:decrease-value", data => fn(data));
		}
		if (action === "input") {
			this.emitter.subscribe("event:input-value", data => fn(data));
		}
	}

	updateVal() {
		return (this.value = parseInt(this.$input.val()));
	}

	increaseValue() {
		return this.$input.val((this.value += 1));
	}

	decreaseValue() {
		return this.$input.val((this.value -= 1));
	}

	checkMaxValue() {
		if (!this.MAX) return false;

		if (this.value > this.MAX || this.value === this.MAX) {
			this.value = this.MAX;
			this.$input.val(this.value);
			return this.$plus.attr("disabled", true);
		}

		return this.$plus.removeAttr("disabled");
	}

	checkMinValue() {
		if (this.value < this.MIN || this.value === this.MIN) {
			this.value = this.MIN;
			this.$input.val(this.value);
			return this.$minus.attr("disabled", true);
		}

		return this.$minus.removeAttr("disabled");
	}
}
